// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1Lhrt","footer":"ModalInfo_footer__3RO58"};